<template>
  <!-- eslint-disable max-len -->
  <svg
    v-if="aiName === 'chat-gpt'"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 47 47"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.5904 3.88928C15.0129 4.9812 12.47 7.67654 12.47 10.3096V22.3736L15.88 24.3425V12.54C15.88 12.0041 16.1659 11.5089 16.6301 11.2409L26.5833 5.49495C24.5916 3.37408 21.5426 2.98821 18.5904 3.88928ZM29.3485 4.11218C26.4179 0.320005 21.636 -0.176926 17.7146 1.01995C14.0506 2.13827 10.4863 4.94602 9.65251 8.66319C4.90629 9.30887 2.08522 13.1972 1.16114 17.1902C0.297891 20.9203 0.94797 25.4055 3.74726 27.9897C1.93824 32.4223 3.89863 36.8081 6.89395 39.6041C9.6916 42.2155 13.8988 43.8974 17.5319 42.7677C20.4626 46.5594 25.2442 47.0563 29.1654 45.8594C32.8298 44.741 36.3944 41.9328 37.2277 38.2151C41.9683 37.5648 44.7856 33.6764 45.7101 29.6861C46.5739 25.9574 45.9277 21.472 43.1329 18.89C44.9417 14.4576 42.9813 10.0719 39.9861 7.27599C37.1885 4.66464 32.9815 2.98279 29.3485 4.11218ZM40.5513 17.1859C41.3838 14.4023 40.1925 11.5725 37.939 9.46903C35.2046 6.91661 31.6 6.06255 29.3201 7.37901L18.88 13.4061V17.3419L29.1 11.4411C29.5641 11.1731 30.1359 11.1731 30.6 11.441L40.5513 17.1859ZM18.88 20.8061V26.0747L23.4392 28.707L28 26.0737V20.8047L23.4412 18.1725L18.88 20.8061ZM26.441 16.4405L36.66 22.3408C37.1241 22.6087 37.41 23.1039 37.41 23.6398V35.1277C40.2367 34.4574 42.0919 32.0116 42.7875 29.009C43.6318 25.3646 42.5697 21.8154 40.29 20.4991L29.8501 14.4721L26.441 16.4405ZM31 22.5369V34.34C31 34.876 30.7141 35.3712 30.2499 35.6391L20.2971 41.3849C22.2888 43.5054 25.3376 43.8911 28.2896 42.9901C31.8672 41.8982 34.41 39.2029 34.41 36.5698V24.5058L31 22.5369ZM28 29.5378L17.7801 35.4387C17.316 35.7066 16.7442 35.7067 16.2801 35.4387L6.32883 29.6939C5.49618 32.4775 6.68748 35.3074 8.94104 37.411C11.6755 39.9634 15.28 40.8175 17.5599 39.501L28 33.474V29.5378ZM17.03 32.4076L20.4393 30.4391L10.22 24.5386C9.7559 24.2707 9.47001 23.7755 9.47001 23.2396V11.7495C6.63736 12.4159 4.77915 14.8624 4.08389 17.8666C3.24131 21.5075 4.30448 25.0587 6.59075 26.381"
      fill="currentColor"
    />
  </svg>
  <!-- eslint-enable max-len -->

  <svg v-if="aiName === 'mistral-ai'" width="365" height="258" viewBox="0 0 365 258" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Mistral AI Logo">
      <path d="M104.107 0H52.0525V51.57H104.107V0Z" fill="#FFD800"/>
      <path d="M312.351 0H260.296V51.57H312.351V0Z" fill="#FFD800"/>
      <path d="M156.161 51.5701H52.0525V103.14H156.161V51.5701Z" fill="#FFAF00"/>
      <path d="M312.353 51.5701H208.244V103.14H312.353V51.5701Z" fill="#FFAF00"/>
      <path d="M312.356 103.14H52.0525V154.71H312.356V103.14Z" fill="#FF8205"/>
      <path d="M104.107 154.71H52.0525V206.28H104.107V154.71Z" fill="#FA500F"/>
      <path d="M208.228 154.711H156.174V206.281H208.228V154.711Z" fill="#FA500F"/>
      <path d="M312.351 154.711H260.296V206.281H312.351V154.711Z" fill="#FA500F"/>
      <path d="M156.195 206.312H0V257.882H156.195V206.312Z" fill="#E10500"/>
      <path d="M364.439 206.312H208.244V257.882H364.439V206.312Z" fill="#E10500"/>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    aiName: {
      type: String,
      required: true,
    },
  },
});
</script>
